import React from 'react'
import { Container } from 'semantic-ui-react'
import "./styles.scss"
export const DoctorEnquire = () => {
    return (<Container className="dash-board">
        hello from Doctor enquire
            </Container>
    )
}
